const circles = document.querySelectorAll('.statistics-module__graph-circle');

const parseStatValue = (raw) => {
  if (!raw) return 0;
  const withoutDecimals = raw.split(',')[0];
  const withoutThousands = withoutDecimals.replace(/\./g, '');
  return parseFloat(withoutThousands) || 0;
};

document.querySelectorAll('.statistics-module__body').forEach((body) => {
  const valueCircles = body.querySelectorAll('.statistics-module__graph-circle[data-value]');
  if (!valueCircles.length) return;

  const max = Math.max(...[...valueCircles].map((el) => parseStatValue(el.dataset.value)));

  valueCircles.forEach((el) => {
    const value = parseStatValue(el.dataset.value);
    el.dataset.target = max ? (value / max) * 100 : 0;
  });
});

circles.forEach((el) => {
  if (el.dataset.target === undefined) {
    el.dataset.target = parseFloat(el.style.getPropertyValue('--percentage')) || 0;
  }
  el.style.setProperty('--percentage', 0);
});

const animateCircle = (el, duration = 2000) => {
  const target = parseFloat(el.dataset.target) || 0;
  const start = performance.now();

  const tick = (now) => {
    const progress = Math.min((now - start) / duration, 1);
    const eased = 1 - (1 - progress) ** 2;
    const value = target * eased;

    el.style.setProperty('--percentage', value.toFixed(2));

    if (progress < 1) requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
};

const io = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      animateCircle(entry.target);
      io.unobserve(entry.target);
    });
  },
  { threshold: 0.5 },
);

circles.forEach((el) => io.observe(el));

// **************************************************
// Counter
// **************************************************
const counterHandler = (entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting || entry.target.classList.contains('is-done')) return;

    entry.target.classList.add('is-done');

    const counterValue = parseFloat(entry.target.getAttribute('data-counter'));
    const decimal = entry.target.getAttribute('data-separator');
    const decimalPlaces = entry.target.getAttribute('data-counter').split('.')[1]?.length ?? 0;
    const isStatic = entry.target.getAttribute('data-static-counter');

    new countUp.CountUp(entry.target, counterValue, {
      decimal,
      decimalPlaces,
      suffix: ' %',
      duration: isStatic ? 0 : 2,
    }).start();
  });
};

const counterModule = document.querySelectorAll('[data-counter]');

if (counterModule.length > 0) {
  const observer = new IntersectionObserver(counterHandler);
  counterModule.forEach((el) => observer.observe(el));
}
